<template>
  <div id="app">

    <Menue @iamCalled="callme($event)" v-bind:profile="profile"/>

    <div class="row">
      <div class="col s12 m4 l2"> <!-- Note that "m4 l3" was added -->
        <LNav/>      
      </div>

      <div class="col s12 m8 l8"> <!-- Note that "m8 l9" was added -->
        <router-view></router-view>
      </div>
      <div class="col s12 m4 l2">
          <RNav />
      </div> 
      

 

      
    </div> <!-- end of row div -->
    
    <Footers/>
    
  </div>

</template>

<script>
// import HelloWorld from './components/HelloWorld.vue'
import Menue from './components/menue.vue'
import Footers from './components/footers.vue'
import LNav from './components/lnav.vue'
import RNav from './components/rnav.vue'

export default {
  name: 'app',
  components: {
    Menue,
    Footers,
    LNav,
    RNav
  },
   data(){
    return {
      profile:''
    }
  },
  methods:{
    callLogins(data){
      //alert('Received event!')
      logins(data);
    },
    signOut(data){
      logUserOut();
  },
  callme(data){
    iamCalled(data);
  }
  },
  created(){
 firebase.auth().onAuthStateChanged(user=> {
    if(user)
      this.profile=user.email; 
    });
  }
  
}
</script>

<style scoped>

</style>
